import React, { useEffect, useRef } from "react";
import { StyleSheet, Pressable, Animated } from "react-native";
import { Button as _Button } from "src/common/assets/mixins";
import Text from "./text";
import variables from "src/common/assets/variables";

const Button = ({
  text = "",
  onPress = () => {},
  solid = true,
  style = {} as any,
  textStyle = {},
  children = null,
  disabled = undefined,
  disabledStyle = {},
  activeOpacity = 0.8,
  hitSlop = { top: 20, bottom: 20, left: 20, right: 20 },
  buttonColor = variables.$buttonColor,
}) => {
  const progressAnimation = useRef(
    new Animated.Value(disabled === true ? 0 : 1)
  ).current;

  const animateDisabled = () => {
    Animated.timing(progressAnimation, {
      toValue: 0,
      duration: 300,
      useNativeDriver: false,
    }).start();
  };

  const animateEnabled = () => {
    Animated.timing(progressAnimation, {
      toValue: 1,
      duration: 300,
      useNativeDriver: false,
    }).start();
  };

  useEffect(() => {
    if (disabled) {
      animateDisabled();
    } else {
      animateEnabled();
    }
  }, [disabled]);

  const interpolatedColor = progressAnimation.interpolate({
    inputRange: [0, 1],
    outputRange: [variables.$disabledButton, buttonColor],
  });

  const animatedStyle = {
    right: progressAnimation.interpolate({
      inputRange: [0, 1],
      outputRange: [style.minWidth || style[0]?.minWidth || 0, 0],
    }),
    backgroundColor: interpolatedColor,
  };

  return (
    <Pressable
      onPress={onPress}
      disabled={disabled}
      hitSlop={hitSlop}
      style={[
        solid && [styles.slidButton],
        styles.loginBtn,
        style,
        solid &&
          disabled !== undefined && [styles.disabledButton, disabledStyle],
      ]}
    >
      {solid && disabled !== undefined && (
        <Animated.View style={[styles.animatedView, animatedStyle]} />
      )}
      {children || <Text style={[{ color: "white" }, textStyle]}>{text}</Text>}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  loginBtn: {
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  animatedView: {
    backgroundColor: "red",
    position: "absolute",
    left: 0,
    bottom: 0,
    top: 0,
    right: 0,
  },
  slidButton: {
    ..._Button,
  },
  disabledButton: {
    backgroundColor: "#B2BEC3",
  },
});

export default Button;
